export const flattenTranslations = (
  prefix: string,
  data: Record<string, unknown>
): Record<string, string> => {
  let result: Record<string, string> = {};
  for (const key of Object.keys(data)) {
    const fullKey: string = prefix ? `${prefix}.${key}` : key;
    const value: unknown = data[key];
    if (value !== null && typeof value === 'object') {
      result = {
        ...result,
        ...flattenTranslations(fullKey, value as Record<string, unknown>),
      };
    } else if (
      typeof value === 'string' ||
      typeof value === 'number' ||
      typeof value === 'boolean'
    ) {
      result[fullKey] = value.toString();
    }
  }
  return result;
};
